<template>
  <v-dialog class="landscape-class" fullscreen :value="open" persistent white hide-overlay>
    <v-container id="landscape-container" class="black" fill-height elevation-12>
      <v-layout class="black" fill-height>
        <v-flex align-self-center d-flex justify-center align-content-center xs12 wrap>
          <h3
            class="bebas headline white--text text-uppercase px-4"
          >The Fooddoneit Application is only functional in portrait mode. Please turn your phone now to continue</h3>
          <v-img width="80%" height="auto" :src="logo"/>
        </v-flex>
      </v-layout>
    </v-container>
  </v-dialog>
</template>

<script>
import logo from "@/assets/fdi-logo-white.png";
export default {
  name: "landscape-error",
  props: {
    open: {
      type: Boolean,
      default: () => false
    }
  },
  data() {
    return {
      logo: logo
    };
  },
  mounted() {},
  methods: {}
};
</script>
<style>
.landscape-class {
  z-index: 1500;
  background-color: black;
}
</style>
